import { FC } from "react";
import { MAX_CONTACT_ATTEMPTS } from "@myapp/contract";
import { getWorkOrderStatusColor } from "../model/workOrderStatus";

interface Props {
  count: number;
}

/**
 * „2/3": how many of the allowed attempts a „Nicht erreicht" Auftrag has used. A solid pill in the
 * status colour with white digits, so it reads next to the status label without a second legend.
 */
export const ContactAttemptsChip: FC<Props> = ({ count }) => (
  <span
    title={`${count} von ${MAX_CONTACT_ATTEMPTS} Versuchen`}
    aria-label={`${count} von ${MAX_CONTACT_ATTEMPTS} Versuchen`}
    style={{ backgroundColor: getWorkOrderStatusColor("NOT_REACHED") }}
    className="inline-grid h-5 min-w-[20px] place-items-center rounded-full px-1.5 text-xs font-bold leading-none tabular-nums text-white"
  >
    {count}/{MAX_CONTACT_ATTEMPTS}
  </span>
);
